<template>
  <div class="tab">
    <div class="top" style="text-align: left; padding-bottom: 10px; border-bottom: none;">
      <div v-if="this.alarmSettings.length > 0">
        <traffic-lights-alarms-settings v-if="user.features.trafficLightsAlarms" v-model="alarmSettings"/>
        <table v-else class="styled-table" >
          <tr v-for="(item, index) in this.alarmSettings" :key="index">
            <td>{{index + 1}}</td>
            <td>
              {{$t(item.label)}}
            </td>
            <td>
              <input type="text" v-model="item.value" class="input-small">
            </td>
            <td>
              <switches v-model="item.active" theme="bootstrap" color="success"></switches>
            </td>
          </tr>
        </table>
        <div class="text-center">
          <button @click="save(true)">
            {{ $t('Save and Close') }}
          </button>
          <button @click="save()">
            {{ $t('Save and Stay') }}
          </button>
        </div>
      </div>
      <h2 v-else-if="!deviceId" class="text-center">
        {{$t('Connect device to the patient first')}}
      </h2>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import axios from 'axios'
import TrafficLightsAlarmsSettings from "./TrafficLightsAlarmsSettings";

export default {
  components: {TrafficLightsAlarmsSettings},
  props: [],
  name: 'AlarmsSettings',
  data () {
    return {
      alarmSettings: [],
      deviceId: null
    }
  },
  computed: {
    ...mapState(['selectedPatient', 'user']),
    excelData() {
      return this.alarms.map((alarm) => {
        return {
          name: alarm.name,
          created: this.$options.filters.formatDate(alarm.created),
          additionalInfo: JSON.stringify(alarm.additional_info)
        }
      })
    }
  },
  methods: {
    loadSettings() {
      this.deviceId = this.selectedPatient && this.selectedPatient.devices_ids ? this.selectedPatient.devices_ids[0] : null
      this.alarmSettings = []
      if (this.deviceId) {
        axios.get(`/api/medical/alarmSettings/${this.deviceId}`, {params: {lang: this.$i18n.locale}}).then(res => res.data.data).then(alarmsSettings => {
          this.alarmSettings = alarmsSettings
        })
        console.log('Loading alarms sittings for device', this.deviceId)
      }
    },

    async save(closeWindow = false) {
      try {
        let res = null
        res = await axios.post(`/api/medical/alarmSettings/${this.deviceId}`, {settings: this.alarmSettings}).then(res => res.data)
        if (res.state === 'ok') {
          this.$notify({text: this.$t('Alarms settings saved'), type: 'success'})
        } else {
          this.$notify({text: this.$t(res.message || 'Alarms settings not saved'), type: 'warn'})
        }

        if (closeWindow) {
          this.hideModal()
        }
      } catch (err) {
        console.error(err)
        this.$notify({text: this.$t('Alarms settings saving error'), type: 'error'})
      }
    },

    ...mapMutations(['hideModal'])
  },
  watch: {
    selectedPatient(newVal, oldVal) { // watch it
      console.log('patient changed: ', newVal, ' | was: ', oldVal)
      this.loadSettings()
    }
  },
  mounted() {
    this.loadSettings()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AlarmsSettings.vue